<template>
  <ProgressBar v-if="loading" data-testid="documents-section-loading" />
  <div v-if="documentables.length">
    <EventDocumentList :documentables="documentables" :root-event="props.rootEvent" />
    <PaginationControl
      v-if="(pageInfo?.totalCount ?? 0) > limit"
      :total="pageInfo?.totalCount ?? 0"
      :page="page"
      :per-page="limit"
      :show-items-per-page="false"
      show-pagination="always"
      class="px-4 py-2"
      data-testid="documents-section-pagination"
      @update:page="page = $event"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue'

import { type DocumentableEventsQuery, useDocumentablesQuery } from '@/gql/myomr'

import EventDocumentList from './EventDocumentList.vue'

const props = defineProps<{
  rootEvent: DocumentableEventsQuery['documentableEvents']['nodes'][number]
}>()

const limit = 100
const page = ref(1)
const offset = computed(() => (page.value - 1) * limit)

const { result, loading } = useDocumentablesQuery(() => ({ event: { id: props.rootEvent.id }, limit, offset: offset.value }))

const documentables = computed(() => result.value?.documentables?.nodes ?? [])
const pageInfo = computed(() => result.value?.documentables?.pageInfo)
const hasDocumentables = computed(() => (pageInfo.value?.totalCount ?? documentables.value.length) > 0)

defineExpose(reactive({ loading, hasDocumentables }))
</script>
